module.exports = __webpack_public_path__ + "img/中繼站1_X按鈕.e6f1b160.png";